import { useI18n } from "../i18n";
import type { StringKey } from "@kikik/i18n";

export type AppMode = "belajar" | "solo" | "online";

/** Mode ids are internal and never translated; only their labels are. */
const MODES: { id: AppMode; label: StringKey; hint: StringKey }[] = [
  { id: "belajar", label: "mode.belajar.label", hint: "mode.belajar.hint" },
  { id: "solo", label: "mode.solo.label", hint: "mode.solo.hint" },
  { id: "online", label: "mode.online.label", hint: "mode.online.hint" },
];

export interface ModeSelectorProps {
  mode: AppMode;
  onChange: (mode: AppMode) => void;
  /**
   * One line instead of two, for the game bar.
   *
   * The hint is not dropped, it moves into the accessible name: three
   * two-line cards were a third of the old header's height, but "Solo, you
   * and 3 bots" is still what a screen reader should say.
   */
  compact?: boolean;
}

export function ModeSelector({ mode, onChange, compact = false }: ModeSelectorProps) {
  const { t } = useI18n();
  return (
    <nav className={`modes ${compact ? "modes--compact" : ""}`} aria-label={t("mode.nav")}>
      {MODES.map((item) => (
        <button
          key={item.id}
          type="button"
          data-mode={item.id}
          className={`modes__item ${mode === item.id ? "modes__item--active" : ""}`}
          aria-current={mode === item.id ? "page" : undefined}
          {...(compact ? { "aria-label": `${t(item.label)}, ${t(item.hint)}` } : {})}
          onClick={() => onChange(item.id)}
        >
          <span className="modes__label">{t(item.label)}</span>
          {compact ? null : <span className="modes__hint">{t(item.hint)}</span>}
        </button>
      ))}
    </nav>
  );
}
